<div class="course-card">
  <div mat-dialog-title>{{ 'Archives' | translate }}</div>

  <mat-form-field class="full-width" appearance="fill">
    <mat-label>{{ 'Filter' | translate }}</mat-label>
    <input matInput [(ngModel)]="searchTerm" (keyup)="filter()" />
    <mat-icon matSuffix>filter_list</mat-icon>
  </mat-form-field>

  @if (type == 'course') {
    <div>
      @if (displayedCourses.length) {
        <div class="result-box">
          @for (course of displayedCourses; track course) {
            <mat-card appearance="outlined" class="result-item">
              <mat-card-content>
                <mat-card-title>
                  <strong>{{ course.actualName || course.name }}</strong>
                </mat-card-title>
                <p class="description">
                  {{ course.actualDescription || course.description }}
                </p>
              </mat-card-content>
              <button mat-flat-button color="primary" [disabled]="loading" (click)="unArchive(course._id)">
                {{ 'Archive.Unarchive' | translate }}
              </button>
            </mat-card>
          }
        </div>
      }
      @if (displayedCourses.length == 0) {
        <div class="text-center p-1">
          {{ 'NoArchiveAvailable' | translate }}
        </div>
      }
    </div>
  }

  @if (type == 'blog') {
    <div>
      @if (displayedBlogs.length) {
        <div class="result-box">
          @for (blog of displayedBlogs; track blog) {
            <mat-card appearance="outlined" class="result-item">
              <mat-card-content>
                <mat-card-title>
                  <strong>{{ blog.actualName || blog.name }}</strong>
                </mat-card-title>
                <p class="description">
                  {{ blog.actualDescription || blog.description }}
                </p>
              </mat-card-content>
              <button mat-flat-button color="primary" [disabled]="loading" (click)="unArchive(blog._id)">
                {{ 'Archive.Unarchive' | translate }}
              </button>
            </mat-card>
          }
        </div>
      }
      @if (displayedBlogs.length == 0) {
        <div class="text-center p-1">
          {{ 'NoArchiveAvailable' | translate }}
        </div>
      }
    </div>
  }
</div>
